import styled, { css } from 'styled-components';
import { owcTheme } from 'core/theme/theme.config';

export const LayoutQuickDetailSectionComponent = styled.div`
    padding: 0 0 24px;
`;

export const LayoutQuickDetailSectionHeaderComponent = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    padding-bottom: 8px;

    owc-typography[variant='subtitle1'] {
        display: flex;
        align-items: center;
    }
`;

export const LayoutQuickDetailSectionContentComponent = styled.div`
    .no-items-description {
        margin-bottom: 8px;
        color: var(--one-color-gray-600);
    }
`;

export const quickDetailExpandableStyles = css`
    owc-expandable {
        margin-top: ${owcTheme['one-spacer-px-16']};

        div > span[slot='title'] {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            width: 100%;

            > .typography-container {
                display: flex;
                flex-direction: column;
            }
        }
    }

    /* OWC-OVERRIDE: let the control row grow past owc's fixed 56px, with v6's 1rem padding.
       owc-expandable exposes no height/padding prop in v7.6.0; height needs !important because
       owc's ":host > .owc-expandable__control-wrapper" rule has equal specificity and would
       otherwise win on source order. Revisit on the next @one upgrade. */
    .owc-expandable > .owc-expandable__control-wrapper {
        height: unset !important;
        padding: ${owcTheme['one-spacer-px-16']};
    }
`;
